export type CardMode = 'flat' | 'raised';
export type CardOrientation = 'horizontal' | 'vertical';
